<template>
    <v-container>
      <v-spacer class="custom-spacer"></v-spacer>
    <v-row>
      <v-col>
        <h2 class="heading-2">Schedule Free Project Consultation</h2>
        <!-- <div id="YCBEmbed"></div> -->
         <br>
         <br>
        <iframe src="https://cny-data-ventures.youcanbook.me/?
embed=true"   
	id="ycbm"

style="width:100%;height:1400px;border:0px;background-color:transparent;"
frameborder="0"   allowtransparency="true"></iframe> 
        <br />
        <br />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

// import LowerFooter from "@/components/LowerFooter.vue";

export default {
  // name: 'YCBEmbed',
  // mounted() {
  //   // Check if the script is already present
  //   if (!document.querySelector('script[src="https://embed.ycb.me"]')) {
  //     const script = document.createElement('script');
  //     script.src = 'https://embed.ycb.me';
  //     script.async = true;
  //     script.setAttribute('data-domain', 'cny-data-ventures');
  //     script.setAttribute('data-displaymode', 'auto');
  //     document.body.appendChild(script);
  //   }
  // },
  data() {
    return {
      components: {
        // LowerFooter
      },
    };
  },
};
</script>

<style scoped>
h3 {
  font-weight: 500;
  color: #2c8591;
}
</style>
